export const content = {
  layout:{
    title:'Correos de aprobación',
    navigation:[
      {name:'Emails',path:'/mails'},
      {name:'Aprobación',path:'/mails/approvals'},
    ],
  },
  table:{
      header:[
          {id:1, label:'ID'},
          {id:2, label:'Nombre'},
          {id:3, label:'Correo'},
          {id:3, label:'Acciones'}
      ]
  }
}
